module.exports = __webpack_public_path__ + "static/media/logo.52e69859.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Regbonus/images/ref_img/logo.png
// module id = 574
// module chunks = 103